"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Container = _interopRequireDefault(require("../../Container"));
var _BilateralSymmetry = _interopRequireDefault(require("../../BilateralSymmetry"));
var _WholeWidth = _interopRequireDefault(require("../../WholeWidth"));
var _VerticalCenter = _interopRequireDefault(require("../../VerticalCenter"));
var _Article = _interopRequireDefault(require("../../Article"));
var _Image = _interopRequireDefault(require("../../Image"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// todo 待删除
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Renderer = function Renderer(restProps) {
  var _a = (restProps || {}).articleList,
    articleList = _a === void 0 ? [] : _a;
  return /*#__PURE__*/_react["default"].createElement(_WholeWidth["default"], null, /*#__PURE__*/_react["default"].createElement(_VerticalCenter["default"], null, /*#__PURE__*/_react["default"].createElement("section", {
    style: {
      overflow: 'hidden'
    }
  }, articleList.map(function (item, index) {
    var _a = item || {},
      content = _a.content,
      title = _a.title;
    return /*#__PURE__*/_react["default"].createElement(_Article["default"], {
      key: index,
      titleStyle: {
        fontSize: '18px',
        color: '#000000',
        lineHeight: '27px'
      },
      contentStyle: {
        fontSize: '14px',
        color: 'rgba(0,0,0,0.60)',
        lineHeight: '21px'
      },
      pc: {
        justifyContent: 'content',
        alignItems: 'center',
        background: 'none',
        //last child mb 0 //todo
        marginBottom: index + 1 === articleList.length ? '0' : '36px'
      },
      mo: {
        paddingTop: '20px'
      },
      article: content,
      title: title
    });
  }))));
};
var ArticleList = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var imageSrc = props.imageSrc,
    _a = props.imageLocation,
    imageLocation = _a === void 0 ? false : _a,
    restProps = __rest(props, ["imageSrc", "imageLocation"]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Container["default"], __assign({
    ref: ref
  }, restProps), !imageLocation ? (/*#__PURE__*/_react["default"].createElement(_BilateralSymmetry["default"], null, /*#__PURE__*/_react["default"].createElement(_WholeWidth["default"], {
    pc: {
      width: '736px',
      height: '552px',
      flex: 'initial',
      paddingRight: '48px'
    },
    mo: {}
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    pc: {
      paddingTop: '',
      height: '100%',
      marginRight: '48px'
    },
    mo: {
      paddingTop: 552 / 736 * 100 + '%'
    },
    source: imageSrc
  })), /*#__PURE__*/_react["default"].createElement(Renderer, __assign({}, restProps)))) : (/*#__PURE__*/_react["default"].createElement(_BilateralSymmetry["default"], {
    mo: {
      flexDirection: 'column-reverse'
    }
  }, /*#__PURE__*/_react["default"].createElement(Renderer, __assign({}, restProps)), /*#__PURE__*/_react["default"].createElement(_WholeWidth["default"], {
    pc: {
      width: '368px',
      height: '491px',
      flex: 'initial',
      paddingLeft: '48px'
    },
    mo: {
      // height: '491px',
    }
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    pc: {
      paddingTop: '',
      height: '100%',
      marginLeft: '48px'
    },
    mo: {
      paddingTop: 245 / 327 * 100 + '%'
    },
    source: imageSrc
  }))))));
});
ArticleList.displayName = 'TCIArticleList';
var _default = exports["default"] = ArticleList;